import qs from 'qs';
/**
 * データ構造
 * @return {
 *  isProcessing: boolean,
 *  currentAuthenticityToken: string,
 *  submitFormUrl: string,
 *  pcrParams: {
 *    pcr_source?: string,
 *    pcr_medium?: string,
 *    pcr_term?: string,
 *    pcr_content?: string,
 *    pcr_campaign?: string
 *  }
 * }
 */
const state = {
  isProcessing: false,
  currentAuthenticityToken: '',
  submitFormUrl: undefined,
  pcrParams: {}
};

const getters = {
  submitFormUrlWithQuery(state){
    const submitPath = state.submitFormUrl.split('?')[0];
    const currentQuery = qs.parse(state.submitFormUrl.split('?')[1] || '');
    const newQueryString = qs.stringify(Object.assign({}, currentQuery, state.pcrParams));
    return `${submitPath}?${newQueryString}`;
  }
}

const actions = {
  setSubmitFormUrl({ commit }, submitFormUrl){
    commit('SET_SUBMIT_FORM_URL', submitFormUrl);
  },
  setIsProcessing({ commit }, status){
    commit('SET_IS_PROCESSING', status);
  },
  setCurrentAuthenticityToken({ commit }, authenticityToken){
    commit('SET_CURRENT_AUTHENTICITY_TOKEN', authenticityToken);
  },
  setPcrParams({ state, commit }, { key, value }) {
    const newPcrParams = Object.assign({}, state.pcrParams, { [key]: value });
    commit('SET_PCR_PARAMS', newPcrParams);
  }
};

const mutations = {
  SET_SUBMIT_FORM_URL(state, submitFormUrl){
    state.submitFormUrl = submitFormUrl;
  },
  SET_IS_PROCESSING(state, status){
    state.isProcessing = status;
  },
  SET_CURRENT_AUTHENTICITY_TOKEN(state, authenticityToken){
    state.currentAuthenticityToken = authenticityToken;
  },
  SET_PCR_PARAMS(state, pcrParams){
    state.pcrParams = pcrParams;
  }
};

export default { namespaced: true, state: () => state, getters, actions, mutations };